import { logout } from '@/utils/auth';
import app from '../main';

const DURATION = 4000;
const HttpErrorList = {
  404: '请求地址错误或后端接口未部署',
  403: '您没有相关权限',
  401: '登录状态过期, 需要重新登录',
  400: '未知错误',
  500: '未知错误',
  502: '无响应',
  504: '请求超时, 可能是网络问题, 请稍后重试'
};

class HttpBizError extends Error {
  constructor(message, request, response) {
    super(message);
    this.name = 'HttpBizError';
    this.request = request;
    this.response = response;
  }
}

class HttpNetworkError extends Error {
  constructor(message) {
    super(message);
    this.name = 'HttpNetworkError';
  }
}

function Catcher(response, isHttpError) {
  if (isHttpError) {
    const { status } = response;
    const baseMessage = '网络请求错误';
    if (status === 403) return false;
    app.$notify.error({
      title: '出错了',
      message: HttpErrorList[status],
      duration: DURATION
    });
    if (status === 401) logout();
    throw new HttpNetworkError(baseMessage);
  } else {
    const { config, data: { info, status, data }, request } = response;
    const baseMessage = '后端接口报错';
    if (!config.noGlobalMessage) {
      app.$notify.error({
        title: '出错了',
        message: info || '未知错误',
        duration: DURATION
      });
    }
    if (status === 2) logout();
    throw new HttpBizError(baseMessage, request, data);
  }
}
export default Catcher;



// WEBPACK FOOTER //
// ./src/api/errCatcher.js